module.exports = __webpack_public_path__ + "static/home-howto-4ec44dfc38f6f82184f751dffbed8a03.jpg";